import {createApp} from 'vue';
import components from './components';

require('instant.page');
require('./csrf');

/**
 * Create a fresh Vue application instance and attach it to the page
 */
createApp({
    components: {
        ...components
    }
}).mount('#app');

window.onscroll = () => {
    const nav = document.querySelector('#navbar');
    if(window.scrollY <= 20) nav.className = 'fixed top-0 w-full z-40 duration-100 header-clear'; else nav.className = 'fixed top-0 w-full z-40 duration-100 header-solid';
};
